import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { SECTION_LABEL } from "@/lib/site";
import { Reveal } from "@/components/Reveal";

// NOTE: this text is mirrored in the FAQPage JSON-LD in public/index.html.
// If you edit answers here, update the JSON-LD to match exactly.
export const FAQS = [
    {
        q: "What types of projects do you build?",
        a: "AI strategy and consulting, workflow automations, custom websites and web applications, AI-powered business solutions, process optimization, and white-label AI development for agencies.",
        id: "project-types",
    },
    {
        q: "Can you work under our agency's brand?",
        a: "Yes. White-label delivery is one of our core services: your agency keeps the client relationship, and we deliver the agreed work behind the scenes, with confidentiality arrangements where agreed.",
        id: "white-label",
    },
    {
        q: "Can you work with international clients?",
        a: "Yes. We work remotely with businesses and agencies across Asia and beyond, using clear written communication and scheduled calls across time zones.",
        id: "international",
    },
    {
        q: "Can you integrate with existing tools?",
        a: "In most cases, yes. If your existing tools provide an API, webhook or data export, we can usually connect them. Feasibility is confirmed during the scoping stage, before any commitment.",
        id: "integrations",
    },
    {
        q: "How is project pricing determined?",
        a: "Pricing depends on scope, integrations, complexity and timeline. After we understand your requirements, you receive a clearly defined quote before any work begins.",
        id: "pricing",
    },
    {
        q: "How long does a project take?",
        a: "It depends on the scope. A timeline is agreed together during the Define stage, once requirements are clear, so you know what to expect before we start.",
        id: "timeline",
    },
    {
        q: "What happens after I submit an inquiry?",
        a: "We review your requirements and reply by email to discuss the details, answer questions and agree on a suitable next step. There is no obligation at this stage.",
        id: "after-inquiry",
    },
];

export default function Faq() {
    return (
        <section id="faq" className="scroll-mt-20 bg-white" data-testid="faq-section">
            <div className="mx-auto max-w-3xl px-6 py-24 lg:px-8 lg:py-32">
                <Reveal>
                    <p className={SECTION_LABEL}>FAQ</p>
                    <h2 className="mt-4 font-heading text-3xl font-medium tracking-tight text-[#1C1917] md:text-4xl lg:text-[3.1rem] lg:leading-[1.1]">
                        Common <span className="font-serif italic text-[#CF4242]">questions.</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
                        {FAQS.map((f, i) => (
                            <AccordionItem key={f.id} value={f.id}>
                                <AccordionTrigger
                                    data-testid={`faq-question-${f.id}`}
                                    className="text-left font-heading text-base font-semibold text-[#1C1917] md:text-lg"
                                >
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent
                                    className="text-sm leading-relaxed text-[#57504A] md:text-base"
                                    data-testid={`faq-answer-${f.id}`}
                                >
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}
